import Vue from "vue";

import {detectIE} from "../vendors/detectIE";

import loginForm from "components/login/loginForm";


const loginPage = new Vue({
    name: "login",
    el: "[data-login]",
    components:{
        loginForm
    }
});


const policy = new Vue({
    name:"policy",
    el: "[data-policy]",
    data : {
      band: true,
    },
    created(){
      if (localStorage.getItem("cookieBand")) {
          this.band = false;
      }
    },
    methods:{
      closeBand(){
        localStorage.setItem("cookieBand", false);
        this.band = false;
      }
    }
  });




window.detectIE = detectIE;
window.Vue = Vue;